// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__13GXH","item":"footer_item__d29Xv"};